import { render, staticRenderFns } from "./DashboardNoticesComponent.vue?vue&type=template&id=61bba00c"
import script from "./DashboardNoticesComponent.vue?vue&type=script&lang=js"
export * from "./DashboardNoticesComponent.vue?vue&type=script&lang=js"
import style0 from "./DashboardNoticesComponent.vue?vue&type=style&index=0&id=61bba00c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports